<template>
  <sl-page>
    <div class='page-filter'>
      <Row :gutter="12">
        <Col span="6" :lg="6" :md="8" :sm="8" :xs="24" class="margin-bottom">
        <Input v-model="params.brandShortName" placeholder="请输入品牌简称"></Input>
        </Col>
        <Col span="18" :lg="18" :md="16" :sm="16" :xs="24" class="page-action">
        <div>
          <Button type="primary" icon="ios-search" @click="list()">搜索</Button>
        </div>
        <div>
          <Button v-permission="'setting.brand.insert'" type="primary" class="margin-right" icon="md-add"" @click=" create()">新增品牌</Button>
          <!-- <Button :disabled="removeDisable" type="error" icon="md-trash" @click="remove()">删除</Button> -->
        </div>
        </Col>
      </Row>
    </div>
    <div class="pg-bd">
      <sl-table ref="table" :loading="loading" :page="page" :columns="columns" :data="data" @on-selection-change="handleSelect" @on-update="handleChange"></sl-table>
    </div>
    <add ref="item" :typeData="typeData" @on-update="handleUpdate"></add>
    <info ref="detail" :typeData="typeData"></info>
  </sl-page>
</template>
<script>
import add from './add'
import info from './info'

let typeData = [{
  value: 0,
  label: '公司'
},{
  value: 1,
  label: '车辆'
},{
  value: 2,
  label: '配件'
},]

export default {
  components: { add, info },
  data() {
    return {
      typeData: typeData,
      columns: [{
          title: '序号',
          type: 'index',
          width: 65,
          align: 'center'
        },
        {
          title: '品牌全称',
          key: 'brandFullName',
          minWidth:120,
        },
        {
          title: '品牌简称',
          key: 'brandShortName',
          minWidth:100,
        },
        {
          title: '品牌图片',
          key: 'brandLogo',
          minWidth:50,
          render: (h, params) => {
            return h('sl-img', {
              props:{
                public:true,
                src:params.row.brandLogo,
                width:'28px',
                height:'28px',
                previewable:false
              }
            })
          }
        },
        {
          title: '品牌类型',
          key: 'type',
          minWidth:80,
          render: (h, params) => {
            let txt = this.typeText(params.row.type)
            return h('div', txt)
          }
        },
        {
          title: '备注',
          key: 'remark',
          minWidth:80,
        },
        {
          title: '操作',
          key: 'action',
          fixed:'right',
          width: 150,
          align: 'center',
          render: (h, params) => {
            let btnSee = h('a', {
              props: {
                type: 'primary',
                size: 'small'
              },
              directives: [
                {
                  name: 'permission',
                  value: 'setting.brand.query',
                }
              ],
              style: {
                marginRight: '5px'
              },
              on: {
                click: () => {
                  this.detail(params)
                }
              }
            }, '详情')
            let btnUpdate = h('a', {
              props: {
                type: 'primary',
                size: 'small'
              },
              style: {
                marginRight: '5px'
              },
              directives: [
                {
                  name: 'permission',
                  value: 'setting.brand.update',
                }
              ],
              on: {
                click: () => {
                  this.update(params.row)
                }
              }
            }, '修改')
            let btnDelete = h('a', {
              props: {
                type: 'primary',
                size: 'small'
              },
              style: {
                marginRight: '5px'
              },
              directives: [
                {
                  name: 'permission',
                  value: 'setting.brand.delete',
                }
              ],
              on: {
                click: () => {
                  this.remove(params.row.id)
                }
              }
            }, '删除')
            let btnArr = []
            btnArr.push(btnSee, btnUpdate, btnDelete)
            return h('div', btnArr)
          }
        }
      ],
      data: [],
      params: {
        name: ''
      },
      page: {
        pageNum: 1,
        pageSize: 10,
        total: 0
      },
      loading: false,
      modalVisible: false,
      selection: []

    }
  },
  computed: {
    removeDisable() {
      return this.selection.length == 0
    }
  },
  created() {},
  mounted() {
    this.list()
  },

  methods: {

    list() {
      let params = { search: { ...this.params }, pageSize: this.page.pageSize, pageNum: this.page.pageNum }
      this.loading = true
      this.$request.brandQuery(params).then(resp => {
        this.loading = false
        if (!resp.code) {
          let listData = resp.data.list
          this.data = this.$utils.conv(listData || [])
          this.page.total = resp.data.total || 0
        }
      })
    },

    detail({ row }) {
      // this.modalVisible = true
      this.detailModalShow(row)
    },

    create() {
      // this.modalVisible = true
      this.addModalShow()
    },

    update(row) {
      // this.modalVisible = true
      this.addModalShow()
      this.$refs['item'].initData(row)
    },

    remove(id) {
      let params = id // { ids: this.selection }
      this.$ui.confirm(this.$request.brandDelete, '确定删除品牌？')(params).then(resp => {
        if (!resp.code) {
          this.$Message.success('删除成功')
          this.selection = []
          this.list()
        }
      })
    },

    handleUpdate() {
      this.modalVisible = false
      this.list()
    },

    handleChange(pageNum, pageSize) {
      if (this.page.pageNum != pageNum || this.page.pageSize != pageSize) {
        this.page.pageNum = pageNum
        this.page.pageSize = pageSize
        this.list()
      }
    },

    handleSelect(selection) {
      this.selection = selection.map(i => i.id)
    },

    $update() {
      this.list()
    },

    addModalShow() {
      this.$refs['item'].show()
    },

    detailModalShow(row) {
      this.$refs['detail'].show()
      this.$refs['detail'].detail(row.id)
    },

    updateState(obj) {
      let params = obj.id
      let tip = obj.state ? '确定启用吗？' : '确定禁用吗？'
      let msg = obj.state ? '启用成功' : '禁用成功'
      this.$ui.confirm(this.$request.ruleUpdateState, tip)(params).then(resp => {
        if (!resp.code) {
          this.$Message.success(msg)
          this.list()
        }
      })
    },

    typeText(key) {
      let str = ''
      this.typeData.forEach(item => {
        if (String(item.value) === String(key)) {
          str = item.label
        }
      })
      return str
    }


  }
}

</script>
